import React, { useEffect, useState } from "react";
import { View } from "react-native";

import {
  Input,
  Empty,
  Error,
  Header,
  Loading,
  CorpCard,
  AnimatedInfinityList,
} from "components";

import { colors, sizes, strings } from "assets/constants";
import { useGetCorps } from "clients/apis";
import css from "styles";
import { useIsFocused } from "@react-navigation/native";
import { liveSearchInput } from "utils";
import { useFlag } from "hooks";

let timer: ReturnType<typeof setTimeout>;

const Corps = () => {
  const {
    isError,
    error,
    isRefetching,
    refetch,
    isLoading,
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useGetCorps();

  const { flg: typing, on: startTyping, off: stopTyping } = useFlag();
  const [search, setSearch] = useState("");

  const isFocused = useIsFocused();
  useEffect(() => {
    isFocused && refetch();
  }, [isFocused]);

  const _renderItem = (item: any) => {
    return (
      <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
        {item?.items?.data?.map((corp: CorpT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <CorpCard corp={corp} refetchCorps={refetch} />
          </View>
        ))}
      </View>
    );
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.items?.data?.length === 0) {
      return <Empty message={strings.no_company} />;
    }

    return (
      <View>
        {/* <View
          style={{
            ...css.paddingH,
            ...css.rowCenterAlign,
            marginTop: sizes.space,
          }}
        >
          <Input
            onChangeText={(text) =>
              liveSearchInput(
                text,
                search,
                setSearch,
                timer,
                startTyping,
                stopTyping
              )
            }
            placeholder={strings.search}
            icon={{ name: "search" }}
            hideError
          />
        </View> */}

        <AnimatedInfinityList
          onRefresh={refetch}
          responseData={data}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          renderItemList={_renderItem}
          paddingTop={sizes.space}
          paddingBottom={100}
        />
      </View>
    );
  };

  return (
    <>
      <Header title={strings.corps} />
      <>{_renderContent()}</>
    </>
  );
};

export default Corps;
